var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScene3DIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0L23.7273 5.26759V12.2339C25.085 12.8168 26.2674 13.5469 27.1677 14.4098C28.2592 15.4545 29 16.7637 29 18.2611C29 20.793 26.9357 22.7394 24.4101 23.975C21.8054 25.2493 18.3003 26 14.5 26C10.6997 26 7.19332 25.2493 4.58991 23.975C2.06427 22.7394 0 20.7943 0 18.2611C0 16.7637 0.740818 15.4558 1.83227 14.4098C2.73259 13.5456 3.915 12.8168 5.27273 12.2339V5.26759L14.5 0ZM5.27273 15.114C4.69198 15.4248 4.15495 15.8081 3.67509 16.2542C2.93164 16.9662 2.63636 17.6485 2.63636 18.2611C2.63636 19.2904 3.5235 20.5699 5.76836 21.6675C7.93545 22.7277 11.02 23.4204 14.5 23.4204C17.98 23.4204 21.0645 22.7277 23.2316 21.6675C25.4765 20.5699 26.3636 19.2904 26.3636 18.2611C26.3636 17.6485 26.0684 16.9662 25.3249 16.2529C24.845 15.8072 24.3079 15.4244 23.7273 15.114V15.7783L14.5 21.0458L5.27273 15.7783V15.114ZM14.3234 17.9516V10.6384L7.90909 7.12233V14.2937L14.3234 17.9516Z",
    fill: "#59B8CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScene3DIcon);
export default __webpack_public_path__ + "static/media/scene-3d-icon.f63476b2e40eac9d74db7d67b9c81f9a.svg";
export { ForwardRef as ReactComponent };